import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {ProtocolEntity} from "./protocol.entity";
import {ProtocolActions} from "./protocol.actions";

@Injectable()
export class ProtocolService {

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector) {
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  add(protocol: ProtocolEntity, synced: boolean = true): Promise<ProtocolEntity> {
    return new Promise((resolve, reject) => {
      if (!synced) {
        this.databaseProvider.createDocumentWithoutInit(protocol)
          .then((protocol: ProtocolEntity) => {
            this.store.dispatch(ProtocolActions.add(protocol));
            resolve(protocol);
          }, () => {
            reject();
          });
      } else {
        this.store.dispatch(ProtocolActions.add(protocol));
        resolve(protocol);
      }
    });
  }

  set(protocol: ProtocolEntity, synced: boolean = true): Promise<ProtocolEntity> {
    return new Promise((resolve, reject) => {
      if (!synced) {
        this.databaseProvider.updateDocument(protocol)
          .then((protocol: ProtocolEntity) => {
            this.store.dispatch(ProtocolActions.set(protocol));
            resolve(protocol);
          }, () => {
            reject();
          });
      } else {
        this.store.dispatch(ProtocolActions.set(protocol));
        resolve(protocol);
      }
    });
  }

  remove(protocol: ProtocolEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocumentById(protocol._id)
        .then(() => {
          this.store.dispatch(ProtocolActions.remove(protocol._id));
        });
    } else {
      this.store.dispatch(ProtocolActions.remove(protocol._id));
    }
  }

  deleteById(_id: string, synced: boolean= true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocumentById(_id)
        .then(() => {
          this.store.dispatch(ProtocolActions.remove(_id));
        });
    } else {
      this.store.dispatch(ProtocolActions.remove(_id));
    }
  }

  getById(id: string): Observable<ProtocolEntity> {
    return this.store.select('protocols').map((protocols: Array<ProtocolEntity>) => {
      return protocols.find((protocol: ProtocolEntity) => {
        return protocol._id === id;
      });
    });
  }

  getAll(): Observable<Array<ProtocolEntity>> {
    return this.store.select('protocols')
      .map((protocols: Array<ProtocolEntity>) => {
        return protocols.filter((protocol: ProtocolEntity) => {
          return !protocol.hasOwnProperty('_deleted') && (!protocol.hasOwnProperty('deleted') || !protocol.deleted);
        })
      })
  }

  public getByIds(ids: Array<string>): Observable<Array<ProtocolEntity>> {
    return this.getAll().map((protocols: Array<ProtocolEntity>) => {
      return protocols.filter((protocol: ProtocolEntity) => {
        return ids.indexOf(protocol._id) !== -1;
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/protocol/protocol.service.ts